/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkLcdDisableRequest} from '../models/BulkLcdDisableRequest';
import type {BulkLcdDisableResponse} from '../models/BulkLcdDisableResponse';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';

export interface DisableLcdSubscriptions$Request {
    bulkLcdDisableRequest: BulkLcdDisableRequest;
    reason?: string;
}

export interface DisableLcdSubscriptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const disableLcdSubscriptionsRequest = createAction<PayloadData<void, DisableLcdSubscriptions$Request>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS__REQUEST');
export const disableLcdSubscriptionsSuccess = createAction<PayloadData<string, DisableLcdSubscriptions$Request>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS__SUCCESS');
export const disableLcdSubscriptionsFailure = createAction<PayloadData<Error, DisableLcdSubscriptions$Request, true>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS__FAILURE');

export const disableLcdSubscriptionsActions = [
    disableLcdSubscriptionsRequest,
    disableLcdSubscriptionsSuccess,
    disableLcdSubscriptionsFailure
] as const;

/**
 * @param {BulkLcdDisableRequest} meta.bulkLcdDisableRequest
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const disableLcdSubscriptions = (meta: DisableLcdSubscriptions$Request, config?: DisableLcdSubscriptions$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: disableLcdSubscriptionsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/users/disable-lcd-subscriptions`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.bulkLcdDisableRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DisableLcdSubscriptionsProgress$Request {
    id: string;
}

export interface DisableLcdSubscriptionsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const disableLcdSubscriptionsProgressRequest = createAction<PayloadData<void, DisableLcdSubscriptionsProgress$Request>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS_PROGRESS__REQUEST');
export const disableLcdSubscriptionsProgressSuccess = createAction<PayloadData<BulkProgress, DisableLcdSubscriptionsProgress$Request>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS_PROGRESS__SUCCESS');
export const disableLcdSubscriptionsProgressFailure = createAction<PayloadData<Error, DisableLcdSubscriptionsProgress$Request, true>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS_PROGRESS__FAILURE');

export const disableLcdSubscriptionsProgressActions = [
    disableLcdSubscriptionsProgressRequest,
    disableLcdSubscriptionsProgressSuccess,
    disableLcdSubscriptionsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const disableLcdSubscriptionsProgress = (meta: DisableLcdSubscriptionsProgress$Request, config?: DisableLcdSubscriptionsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: disableLcdSubscriptionsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/disable-lcd-subscriptions/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DisableLcdSubscriptionsResult$Request {
    id: string;
}

export interface DisableLcdSubscriptionsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const disableLcdSubscriptionsResultRequest = createAction<PayloadData<void, DisableLcdSubscriptionsResult$Request>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS_RESULT__REQUEST');
export const disableLcdSubscriptionsResultSuccess = createAction<PayloadData<BulkLcdDisableResponse, DisableLcdSubscriptionsResult$Request>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS_RESULT__SUCCESS');
export const disableLcdSubscriptionsResultFailure = createAction<PayloadData<Error, DisableLcdSubscriptionsResult$Request, true>>('BULK_LCD_SUBSCRIPTION_DISABLE__DISABLE_LCD_SUBSCRIPTIONS_RESULT__FAILURE');

export const disableLcdSubscriptionsResultActions = [
    disableLcdSubscriptionsResultRequest,
    disableLcdSubscriptionsResultSuccess,
    disableLcdSubscriptionsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const disableLcdSubscriptionsResult = (meta: DisableLcdSubscriptionsResult$Request, config?: DisableLcdSubscriptionsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: disableLcdSubscriptionsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/disable-lcd-subscriptions`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopSubscriptionDisable$Request {
    id: string;
}

export interface StopSubscriptionDisable$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopSubscriptionDisableRequest = createAction<PayloadData<void, StopSubscriptionDisable$Request>>('BULK_LCD_SUBSCRIPTION_DISABLE__STOP_SUBSCRIPTION_DISABLE__REQUEST');
export const stopSubscriptionDisableSuccess = createAction<PayloadData<void, StopSubscriptionDisable$Request>>('BULK_LCD_SUBSCRIPTION_DISABLE__STOP_SUBSCRIPTION_DISABLE__SUCCESS');
export const stopSubscriptionDisableFailure = createAction<PayloadData<Error, StopSubscriptionDisable$Request, true>>('BULK_LCD_SUBSCRIPTION_DISABLE__STOP_SUBSCRIPTION_DISABLE__FAILURE');

export const stopSubscriptionDisableActions = [
    stopSubscriptionDisableRequest,
    stopSubscriptionDisableSuccess,
    stopSubscriptionDisableFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopSubscriptionDisable = (meta: StopSubscriptionDisable$Request, config?: StopSubscriptionDisable$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopSubscriptionDisableActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/disable-lcd-subscriptions`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

